/**
 * Gets an API based on an identifier.
 * @param identifier - API identifier.
 * @returns API or null if not found.
 */
export function getAPI(identifier) {
    var _a, _b, _c, _d;
    if (typeof window === 'undefined') {
        return null;
    }
    if (!((_b = (_a = window.SYDLE) === null || _a === void 0 ? void 0 : _a.api) === null || _b === void 0 ? void 0 : _b[identifier])) {
        return null;
    }
    return (_d = (_c = window.SYDLE) === null || _c === void 0 ? void 0 : _c.api) === null || _d === void 0 ? void 0 : _d[identifier];
}
